import * as types from './mutation-types'

export const loadOrders = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('orders/collection').then((response) => {
            commit(types.ADD_ORDERS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const createOrder = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/order', data).then((response) => {
            commit(types.ADD_ORDER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateOrder = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`update/${data.id}/order`, data).then((response) => {
            commit(types.UPDATE_ORDER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateOrderStatus = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`update/order/${data.id}/status`, data).then((response) => {
            commit(types.UPDATE_ORDER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadOrderStatus =  ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('order/status/enum').then((response) => {
            commit(types.LOAD_ORDER_STATUS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getOrderById =  ({commit, dispatch, state}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`order/${id}`).then((response) => {
            commit(types.SET_CURRENT_ORDER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadOrderPdf = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`download/order/${id}/pdf`, { responseType: 'blob' })
        .then((response) => {
            console.log(response)
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'order_invoice.pdf');
            document.body.appendChild(link);
            link.click();
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendOrderInvoice = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`send/order/${id}/invoice/email`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendOrder = ({ commit }, { id, to, cc, subject, message }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`order/${id}/send`, { to, cc, subject, message }).then((response) => {
            commit(types.UPDATE_ORDER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}